module.exports = __webpack_public_path__ + "img/ico_logo.9d6f68b9.svg";